import React from 'react';
import { ClassiqueVertical } from './ClassiqueVertical';
import { ClassiqueVerticalSelected } from './ClassiqueVerticalSelected';
import { LameVertical } from './LameVertical';
import { LameVerticalSelected } from './LameVerticalSelected';

export type FlooringLayoutProps = { fillColor?: string; svgProps?: React.SVGProps<SVGSVGElement> };
export class FlooringLayoutAssets {
    public static LameVertical = ({ props = {} }: { props?: FlooringLayoutProps }) => <LameVertical props={props} />;
    public static LameVerticalSelected = () => <LameVerticalSelected />;

    public static ClassiqueVertical = ({ props = {} }: { props?: FlooringLayoutProps }) => (
        <ClassiqueVertical props={props} />
    );
    public static ClassiqueVerticalSelected = () => <ClassiqueVerticalSelected />;
}
